<template>
  <editor default-tab="device_read" :tabs="tabs"></editor>
</template>

<script>
import Editor from '@/components/Editor'
import DeviceRead from './editor/Read'

export default {
  components: {
    Editor
  },
  data () {
    return {
      tabs: [
        {title: "Device read", name: "device_read",      component: DeviceRead}
      ]
    }
  }
}
</script>
